import PropTypes from 'prop-types';
import React from 'react';
import { Modal } from "react-bootstrap";
import {
  renderTableDealsColumns,
  renderTableDealsRows,
} from "../dashboard-util/dashboard-utils";
import "./dashboard-real-estate.scss";
import "../../tasks/scenes/tasks-comments/shared-modal-header.scss";

const DealModal = ({
  selectedMember,
  showState,
  onHideFunction
}) => {
  const hasDealTracker = selectedMember?.DealTracker && selectedMember?.DealTracker.length > 0;

  const itemId = hasDealTracker
    ? selectedMember?.DealTracker[0]?.ProjectId
    : null;

  const itemName = hasDealTracker
    ? selectedMember?.DealTracker[0]?.ProjectName
    : "";

  const keyRight = selectedMember.UserId ?? 0;
  const keyLeft  = selectedMember.ProjectId ?? 0;
  const keyMiddle = itemId ?? 0;

  const key = `${keyLeft}-${keyMiddle}-${keyRight}-${itemName}`;

  return (
    selectedMember && (
      <Modal
        key={key}
        show={showState}
        onHide={onHideFunction}
        contentClassName="deal-and-vacation-date-real-estate-modal-styles"
        dialogClassName="deal-and-vacation-date-real-estate-modal"
        backdropClassName="real-estate-modal-backdrop"
        scrollable={true}
      >
        <div className="popup-week real-estate-deal">
          <Modal.Header className="header-popup" closeButton>
            <div className="real-estate-deal-task-name">
              <div className="real-estate-deal-user-name">
                {selectedMember.Name}
              </div>
            </div>
          </Modal.Header>
          <hr></hr>
          <Modal.Body className="header-body">
            <div className="real-estate-table-container">
              <div className={`${true ? "table-wrapper" : ""}`}>
                <table className="real-estate-modal-table tableSticky">
                  {selectedMember.DealTracker.map((deal, index) => (
                    <React.Fragment key={deal.ProjectId}>
                      { index === 0 &&
                        <React.Fragment key={`col-${key}`}>
                          {renderTableDealsColumns(deal.TableDeals[0].Columns)}
                        </React.Fragment>
                      }
                      { deal.TableDeals.map((tableDeal, rowIndex) =>
                          <React.Fragment key={`row-${rowIndex}`}>
                            {renderTableDealsRows(
                              tableDeal.Rows, -1,
                              deal.TableDeals[0]
                                .Columns
                                  .find(m => ["active?", "active ?", "active"]
                                  .includes(m?.Name?.toLowerCase()))?.Id
                            )}
                          </React.Fragment>
                        )
                      }
                    </React.Fragment>
                  ))}
                </table>
              </div>
            </div>
          </Modal.Body>
        </div>
      </Modal>
    )
  );
};

DealModal.propTypes = {
    selectedMember: PropTypes.shape({
    UserId: PropTypes.number.isRequired,
    ProjectId: PropTypes.string,
    Name: PropTypes.string.isRequired,
    DealTracker: PropTypes.arrayOf(PropTypes.shape({
      ProjectId: PropTypes.number.isRequired,
      ProjectName: PropTypes.string.isRequired,
      AllowDealsEdit: PropTypes.bool.isRequired,
      TableDeals: PropTypes.array.isRequired,
    })),
  }).isRequired,
  showState: PropTypes.bool.isRequired,
  onHideFunction: PropTypes.func.isRequired
};

export default DealModal;
